import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
  BACKEND_HOST: 'http://localhost:3000',

  firebase: {
    apiKey: 'AIzaSyBysGwG33MdlSW3zPX88ebwW_gt8e5i9dQ', //localhost
    authDomain: 'cpqdcloud-dev.firebaseapp.com',
  },

  // QGIS_HOST:'localhost:8380'
  QGIS_PATH:
    'https://datasafra-backend-api-gateway-3tfjxbph.uc.gateway.dev/qgis',

  // Debug flag para pular autenticação em desenvolvimento
  skipAuth: false,
  MARTIN_HOST: 'datasafra-mvt-server-299159640197.us-central1.run.app',
  MARTIN_PROTOCOL: 'https',
  GOOGLE_API_KEY: 'AIzaSyDlb_YFnlAEJK2oR__A9v_0sCoC1XvlRuA', //localhost
  CONTACT_URL: 'https://conteudo.geoambiente.com.br/pre-lancamento-datasafra',
  agentRuntimeUrl: 'http://localhost:3000/agent',
};
